export interface ISelectOption<T> {
    label: string;
    value: T;
    key?: string;
}

export const SiteFilterKeys = {
    // Filters
    controlProviderId: 'control_provider_id',
    utility: 'site_utility',
    market: 'market',
    status: 'status',
    programId: 'program_id',
    utilityCustomerId: 'utility_customer_id',
    caisoResource: 'caisoResource',

    // Options
    dispatchType: 'dispatch_type',
    hasVen: 'hasVen',
    resourceTelemetryStatus: 'resource_telemetry_status',
    intervalData: 'interval_data',
    existSalesforceMeterEnrollments: 'exist_salesforce_meter_enrollments',
    existSalesforceMeters: 'exist_salesforce_meters',
    isClosed: 'isClosed',
} as const;

export type TSiteFilterKey = (typeof SiteFilterKeys)[keyof typeof SiteFilterKeys];

export const SiteFilterUnderOptionKeys: TSiteFilterKey[] = [
    SiteFilterKeys.dispatchType,
    SiteFilterKeys.intervalData,
    SiteFilterKeys.existSalesforceMeterEnrollments,
    SiteFilterKeys.existSalesforceMeters,
    SiteFilterKeys.isClosed,
    SiteFilterKeys.hasVen,
    SiteFilterKeys.resourceTelemetryStatus,
];

export const SiteFilterLabels = {
    [SiteFilterKeys.controlProviderId]: 'Control Provider',
    [SiteFilterKeys.utility]: 'Utility',
    [SiteFilterKeys.market]: 'Market',
    [SiteFilterKeys.status]: 'Status',
    [SiteFilterKeys.programId]: 'Program',
    [SiteFilterKeys.utilityCustomerId]: 'Utility Customer',
    [SiteFilterKeys.caisoResource]: 'CAISO Resource',

    [SiteFilterKeys.dispatchType]: 'Dispatch Type',
    [SiteFilterKeys.intervalData]: 'Data',
    [SiteFilterKeys.existSalesforceMeterEnrollments]: 'Meter Enrollments',
    [SiteFilterKeys.existSalesforceMeters]: 'Meters',
    [SiteFilterKeys.isClosed]: 'Show Closed Sites',
    [SiteFilterKeys.hasVen]: 'Has VEN',
    [SiteFilterKeys.resourceTelemetryStatus]: 'Resource Status',
} as const;
